// src/components/Hero.tsx
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import AnimatedSection from "./AnimatedSection";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

const Hero = () => {
  const isMobile = useIsMobile();

  const scrollToAbout = () => {
    const aboutSection = document.getElementById("about");
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="min-h-screen flex flex-col justify-center relative overflow-hidden px-4">
      <div className="absolute inset-0 -z-10">
        <div
          className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(120,119,198,0.1),transparent_60%)]"
          aria-hidden="true"
        />
        <div
          className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(120,119,198,0.1),transparent_60%)]"
          aria-hidden="true"
        />
      </div>

      <div className="container mx-auto max-w-5xl">
        <AnimatedSection className="mb-6" variant="fade-down">
          <h3 className="text-muted-foreground text-lg md:text-xl mb-2">Hello, I'm</h3>
        </AnimatedSection>

        <AnimatedSection className="mb-6" variant="fade-up" delay={200}>
          <h1
            className={cn(
              "font-bold mb-4 tracking-tight",
              isMobile ? "text-4xl" : "text-5xl md:text-7xl lg:text-8xl"
            )}
          >
            Priya Pareek
          </h1>
        </AnimatedSection>

        <AnimatedSection variant="fade-up" delay={400}>
          <h2
            className={cn(
              "font-display mb-8 text-muted-foreground",
              isMobile ? "text-xl" : "text-2xl md:text-3xl lg:text-4xl"
            )}
          >
            Visual Artist & Designer
          </h2>
        </AnimatedSection>

        <AnimatedSection variant="fade-up" delay={600} className="max-w-xl">
          <p className="text-lg mb-8 leading-relaxed">
            I create experiences that make people's lives simple. A multidisciplinary artist with over a decade of expertise in design, illustration and visual arts.
          </p>
        </AnimatedSection>

        <AnimatedSection variant="fade-up" delay={800}>
          <div className="flex flex-wrap gap-4">
            <Button asChild size="lg" className="text-base">
              <Link to="/work">View My Work</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="text-base">
              <Link to="/contact">Contact Me</Link>
            </Button>
          </div>
        </AnimatedSection>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <Button
          variant="ghost"
          size="icon"
          aria-label="Scroll down"
          onClick={scrollToAbout}
        >
          <ChevronDown className="h-6 w-6" />
        </Button>
      </div>
    </section>
  );
};

export default Hero;